module.exports = __webpack_public_path__ + "static/img/zhuxing.af139ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zhuxing.png
// module id = 66UW
// module chunks = 1